import { Outlet, useNavigate, useParams } from "react-router-dom";
import YearDropDown from "../components/YearDropDown";
import Season from "../components/Season";
import LoginButton from "../components/LoginButton";
import SearchField from "../components/SearchField";

export default function Layout() {
  const navigate = useNavigate();
  const { yearParam, weekendKey } = useParams();
  const year = yearParam ? parseInt(yearParam) : new Date().getFullYear();
  
  return (
    <>
      <div className='w3-light-grey w3-padding flex-wrap flex-align-items-center flex-gap'>
        <button
          className="w3-button w3-left-align flex"
          style={{
            paddingLeft: '60px',
            backgroundImage: `url(${process.env.PUBLIC_URL}/Chequered_flag.png)`,
            backgroundPosition: 'left center',
            backgroundSize: 'auto 60px',
            backgroundRepeat: 'no-repeat'
          }}
          onClick={() => {
            navigate('/' + year);
          }}
        >
          <h1>Saison {year}</h1>
        </button>
        <YearDropDown input={year} />
        <div className="flex-grow"></div>
        <SearchField />
        <LoginButton />
      </div>
      <div className="flex flex-grow">
        <div className="w3-hide-small leftBar w3-light-grey h100 scroll">
          <div>
            <Season year={year} currentWeekend={weekendKey} />
          </div>
        </div>

        <div className="flex-grow scroll">
          <Outlet />
        </div>
      </div>
    </>
  );
}
